
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3092_330356)","stroke":"#748190","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.143 4.592h13.714M2.857 4.592h10.286v10.285A1.143 1.143 0 0112 16.02H4a1.143 1.143 0 01-1.143-1.143V4.592zM5.143 4.592V4.02a2.857 2.857 0 015.714 0v.572"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3092_330356"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .592)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    